/**
 * US currency formatting helpers for input fields.
 *
 * Pattern: store the *raw* numeric string in form state (e.g. "12500" or "12500.75"),
 * render it with comma-grouping + a `$` prefix (e.g. "$12,500" / "$12,500.75"),
 * and parse user input back to a clean digit string on every keystroke.
 *
 * This keeps `parseFloat()` on submit working unchanged.
 */

/**
 * Render a raw numeric string as USD with commas. Preserves a trailing decimal
 * point so the user can keep typing past it (e.g. "1234." → "1,234.").
 *
 * @param {string|number} raw
 * @param {{ withSymbol?: boolean }} [opts]  Set `withSymbol:false` if the input
 *        already shows a separate `$` adornment.
 */
export function formatUSD(raw, { withSymbol = true } = {}) {
  if (raw === "" || raw == null) return "";
  const cleaned = String(raw).replace(/[^0-9.]/g, "");
  if (!cleaned) return "";
  const [intPart, ...rest] = cleaned.split(".");
  const decPart = rest.join(""); // collapse extra dots
  const intFmt = intPart === "" ? "0" : Number(intPart).toLocaleString("en-US");
  const body = cleaned.includes(".") ? `${intFmt}.${decPart.slice(0, 2)}` : intFmt;
  return withSymbol ? `$${body}` : body;
}

/** Strip everything except digits + a single dot from a formatted USD string. */
export function parseUSD(formatted) {
  if (!formatted) return "";
  return String(formatted).replace(/[^0-9.]/g, "");
}
